import { useEffect } from 'react'

import { useAppSelector } from '~/redux/hooks'
import { selectUserId } from '~/auth/slices/auth.slice'

export default function useCleanup(cleanupFunc: (...args: unknown[]) => void): void {
  const userId = useAppSelector(selectUserId)

  useEffect(() => {
    if (userId != null) {
      window.addEventListener('beforeunload', cleanupFunc)
    }

    return () => {
      cleanupFunc()
      window.removeEventListener('beforeunload', cleanupFunc)
    }
  }, [cleanupFunc, userId])
}
